import { MutableState } from '../State';
import { rescueLevelGetActive } from './rescueLevel.getters';
import {
  rescueLevelsPerSequence,
  type RescueLevelOABucket,
} from './rescueLevel.ruleset';

/** Complete the current active rescue level. */
export function rescueLevelComplete(state: MutableState): boolean {
  const active = rescueLevelGetActive(state);
  if (!active) return false;

  if (!state.rescueLevel) state.rescueLevel = {};

  const playedLevels = state.rescueLevel.playedLevels ?? [];
  if (playedLevels.includes(state.match2.level)) return false;

  if (!state.rescueLevel.playedLevels) state.rescueLevel.playedLevels = [];
  state.rescueLevel.playedLevels.push(state.match2.level);

  const campaignComplete =
    state.rescueLevel.playedLevels.length >= rescueLevelsPerSequence;
  if (campaignComplete) delete state.rescueLevel.activeBucket;

  return true;
}

function rescueLevelGetBucketForCreative(
  creativeID: string,
): RescueLevelOABucket | undefined {
  switch (creativeID) {
    case '2025-10-20-rescue-fire':
    case '2025-11-19-house_on_fire_rescue':
      return 'oa_fire';
    case '2025-10-20-rescue-drowning':
    case '2026-07-17-drowning_rescue':
      return 'oa_drowning';
    case '2026-07-21-rescue_crocodile':
      return 'oa_crocodile';
    case '2026-07-22-frozen_rescue':
      return 'oa_frozen';
    default:
      return undefined;
  }
}

/** Activate a fresh rescue sequence for every recognized OA delivery. */
export function rescueLevelActivateFromOA(
  state: MutableState,
  creativeID: string,
): void {
  const bucket = rescueLevelGetBucketForCreative(creativeID);
  if (!bucket) return;

  if (!state.rescueLevel) state.rescueLevel = {};
  state.rescueLevel.activeBucket = bucket;
  state.rescueLevel.playedLevels = [];
}
